<div id="w3l-appointment" style="width: 800px;">
  <section class="appointment-section section-gap" >
    <div class="wrapper">


          <form action="#" method="post" >
            <div class="fields-grid" >
              <div class="styled-input" >
                <label style="width: 300px;">Mortality Informations</label>
              </div>
              <!---------- ********** Pre-Medication Treatment table *****--------->
              <div class="appointment-form-field" style="width: 800px;border-collapse: collapse;">
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 200px;text-align: center;">  Mortality Reason</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 225px;align-tracks: center;">  Mortality Date</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 350px;align-tracks: center;">  Notes</label>
              </div>
              <div class="appointment-form-field" style="width: 800px;border-collapse: collapse;">
                  <select id="pharmgroups" name="pharmgroups0" required="" style="width: 200px;background-color: white;" [(ngModel)]="mortalityreason"  >
                    <option value="">Non</option>
                    <option value="Palliative">Palliative</option>
                    <option value="Disease related">Disease related</option>
                    <option value="Treatment  related">Treatment  related</option>
                    <option value="Co.Morbidity">Co.Morbidity</option>
                    <option value="Others">Others</option>
                  </select>
                  <input type="date" name="dte" required=""  style="width: 225px;background-color: white;font-size: small;" [(ngModel)]="mortalidate">

                  <input type="text" name="notes" required="" placeholder=""style="width: 350px;background-color: white;font-size: small;" [(ngModel)]="mortalitynotes">
                </div>

              <BR>
              <BR>
            <div style="text-align: center; ">
                <button type="button" class="theme-button btn" name="submit" (click)="submitmortality()" >Submit</button>
                <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()"  >Delete</button>
                <button type="button" class="theme-button btn" name="New" (click)="CloseDialog()">Close</button>
            </div>
            <div class="clear">

            </div>
          </div>
          </form>




    </div>
  </section>
</div>

